var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"news-list",class:("news-list--" + _vm.type)},[_c('grid-container',[_c('grid-row',_vm._l((_vm.articles),function(article,i){return _c('div',{key:i,staticClass:"news-list__article"},[_c('article-component',{attrs:{"heading":article.title,"description":article.desc,"photo":article.photo,"link":article.link}})],1)}))],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c864ce6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/NewsList.vue
// module id = null
// module chunks = 